import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Pipe({
  name: 'validationErrorKeys',
  standalone: true
})

export class ValidationErrorKeysPipe implements PipeTransform {

  transform(errors: ValidationErrors | null): string[] {
    if (!errors) {
      return [];
    }
    return Object.keys(errors);
  }

}

export const validationMessages: ValidationErrors = {
  required: 'Required',
  minlength: 'Too Short',
  maxlength: 'Too Long',
  pattern: 'Invalid Entry',
  email: 'Invalid Entry',
  date: 'Invalid Date',
};
